import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "../assests/css/custom-style.css";
import regency from "../assests/images/Regency Luxury Suites.webp";
import habtoor from "../assests/images/Al Habtoor Grand Resort.webp";
import bandra from "../assests/images/Al Bandar Rotana.webp";

// Dummy logos
const partners = [
    { id: 1, logo: regency, alt: "Regency Luxury Suites" },
    { id: 2, logo: habtoor, alt: "Al Habtoor Grand Resort" },
    { id: 3, logo: bandra, alt: "Al Bandar Rotana.webp" },
];

export default function TrustedPartners() {
    return (
        <section className="py-10 sm:py-12 md:py-16 lg:py-20 bg-gradient-to-b from-white to-orange-50/30">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

                {/* Heading */}
                <div className="text-center mb-12">

                    <span className="inline-flex items-center px-4 py-2 rounded-full bg-orange-50 text-[#FF6B35] text-sm font-semibold mb-4">
                        Trusted Hotel Partners
                    </span>

                    <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
                        Partner Hotels & Resorts
                    </h2>

                    <p className="text-slate-500 mt-3 max-w-2xl mx-auto">
                        We work with Dubai's leading hotels and resorts to bring you
                        exceptional stays, exclusive rates, and premium experiences.
                    </p>

                </div>

                {/* Static centered grid */}
                <div className="flex justify-center">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

                        {partners.map((partner) => (
                            <div
                                key={partner.id}
                                className="group relative bg-white rounded-[30px] border border-orange-100 shadow-lg hover:shadow-2xl overflow-hidden transition-all duration-500"
                            >

                                {/* Top Accent */}
                                <div className="h-1 bg-[#FF6B35]"></div>

                                <div className="p-8 flex items-center justify-center h-[220px]">

                                    <img
                                        src={partner.logo}
                                        alt={partner.alt}
                                        className="max-h-36 object-contain group-hover:scale-105 transition duration-500"
                                    />

                                </div>

                            </div>
                        ))}

                    </div>
                </div>

            </div>
        </section>
    );
}